export default "__VITE_ASSET__siDzTQoU__"